import { resolveCurrentPlanIndex } from '../components/Auth/SubscriptionPlan/subscriptionPlanMatrixContext';

/** Whether a plan should appear on customer-facing subscription / pricing tables. */
export const isPlanDisplayedOnSubscriptionTable = (plan) =>
	plan?.displayOnPlanTable !== false;

/**
 * Filter plans for subscription comparison tables.
 * Keeps the subscriber's current plan visible even when hidden from the catalog.
 */
export const filterPlansForSubscriptionTable = (
	plans = [],
	{ subscriptionPriceId, planMongoId, planId, currentPlanName, isYearly = false } = {},
) => {
	const list = Array.isArray(plans) ? plans : [];
	if (!list.length) return [];

	const currentIdx = resolveCurrentPlanIndex(
		list,
		{
			subscriptionPriceId,
			planId: planMongoId || planId,
			planName: currentPlanName,
		},
		isYearly,
	);
	const currentPlan = currentIdx >= 0 ? list[currentIdx] : null;
	const currentKey = currentPlan ? String(currentPlan._id || currentPlan.id || '') : '';

	return list.filter((plan) => {
		if (isPlanDisplayedOnSubscriptionTable(plan)) return true;
		if (!currentKey) return false;
		return String(plan._id || plan.id || '') === currentKey;
	});
};
